module.exports = __webpack_public_path__ + "img/bread_tex.2f9d6403.jpg";